import { render, staticRenderFns } from "./OrderTagNew.vue?vue&type=template&id=5493dcfc&"
import script from "./OrderTagNew.vue?vue&type=script&lang=js&"
export * from "./OrderTagNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports